import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ErrorMessageQuery } from '../../../../../shared/models/error-messages/error-message-query';
import { CloseIconComponent } from '../../../icons/close-icon/close-icon.component';
import { FormsModule } from '@angular/forms';
import { pascalCaseToWords } from '../../../../common/common-utils';
import { BaseFilter } from '../../../base/base-filter';
import { AgentActionDirective } from '../../../../directives/agent-action.directive';
import { ThreeStateToggleComponent } from '../../../common/three-state-toggle/three-state-toggle.component';

@Component({
  selector: 'app-error-message-filter',
  imports: [CloseIconComponent, FormsModule, AgentActionDirective, ThreeStateToggleComponent],
  templateUrl: './error-message-filter.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './error-message-filter.component.scss',
})
export class ErrorMessageFilterComponent extends BaseFilter<ErrorMessageQuery> implements OnInit {
  @Input() public recyclingModeEnabled = false;

  public pascalCaseToWords = pascalCaseToWords;

  constructor() {
    const defaultFilter: ErrorMessageQuery = {
      searchInCode: true,
      searchInDetailsOnTerminal: true,
      searchInHeaderOnTerminal: true,
      hasCategoryAlert: true,
      hasCategoryWarning: true,
      hasCategoryInfo: true,
    };
    super(400, defaultFilter);
  }

  public override ngOnInit(): void {
    super.ngOnInit();
    this.searchQuery.searchInCode = this.defaultFilter.searchInCode;
    this.searchQuery.searchInDetailsOnTerminal = this.defaultFilter.searchInDetailsOnTerminal;
    this.searchQuery.searchInHeaderOnTerminal = this.defaultFilter.searchInHeaderOnTerminal;
    this.searchQuery.hasCategoryAlert = this.defaultFilter.hasCategoryAlert;
    this.searchQuery.hasCategoryWarning = this.defaultFilter.hasCategoryWarning;
    this.searchQuery.hasCategoryInfo = this.defaultFilter.hasCategoryInfo;
  }
}
